import Head from "next/head";

import { processJsonSchema } from "../utils";

interface NewType {
  config: any;
}

type Props = NewType;

const AboutSchema = ({ config }: Props) => {
  return (
    <Head>
      <script
        id="about-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: config,
        }}
      >
        {}
      </script>
    </Head>
  );
};

export default AboutSchema;
